import { AccountApiError } from "./accountApi";

export function accountErrorMessage(error: unknown): string {
  if (error instanceof AccountApiError) {
    if (error.status === 401) {
      return "Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.";
    }
    if (error.status === 403) {
      return "Für diese Aktion fehlt die Freischaltung.";
    }
    if (error.status === 404) {
      return "Dieser Dienst ist derzeit nicht erreichbar. Bitte versuchen Sie es später erneut.";
    }
    if (error.status === 503) {
      if (error.message.includes("stripe")) {
        return "Die Online-Abrechnung ist noch nicht freigeschaltet.";
      }
      return "Dieser Dienst ist vorübergehend nicht verfügbar.";
    }
    if (error.message === "current password incorrect") {
      return "Das aktuelle Passwort ist nicht korrekt.";
    }
    if (error.message.includes("password must be at least")) {
      return "Das neue Passwort muss mindestens 8 Zeichen haben.";
    }
    if (error.message && !/^HTTP \d+$/.test(error.message) && !error.message.includes("stripe")) {
      return error.message;
    }
  }

  const message = error instanceof Error ? error.message : String(error);
  if (message === "current password incorrect") {
    return "Das aktuelle Passwort ist nicht korrekt.";
  }
  if (message.includes("password must be at least")) {
    return "Das neue Passwort muss mindestens 8 Zeichen haben.";
  }
  if (message.includes("401") || message.includes("unauthorized")) {
    return "Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.";
  }
  if (message.includes("Failed to fetch") || message.includes("network") || message.includes("fetch")) {
    return "Die Verbindung zum Konto-Service ist fehlgeschlagen. Bitte versuchen Sie es erneut.";
  }
  return "Die Anfrage ist fehlgeschlagen. Bitte versuchen Sie es später erneut.";
}
